module.exports = __webpack_public_path__ + "static/questionnaire-cd6ab18d475a30e2d141c21f953b3121.png";